import { BriefcaseIcon, SparkleIcon } from "@phosphor-icons/react";

type Props = {
  eyebrow: string;
  title: string;
  description: string;
  points: string[];
  onContinue: () => void;
};

export const SectionTransition = ({ eyebrow, title, description, points, onContinue }: Props) => (
  <section className="mx-auto flex min-h-full w-full max-w-[680px] flex-col justify-center py-4 sm:py-7">
    <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-emerald-500">{eyebrow}</p>

    <h1
      className={`mt-3 bg-gradient-to-r from-[#4652B8] via-[#5F6DDD] to-[#7482EB] bg-clip-text text-2xl font-bold leading-tight tracking-tight text-transparent sm:text-[34px]`}
    >
      {title}
    </h1>

    <p className="mt-4 max-w-xl text-sm leading-6 text-[#272D6D]/80">{description}</p>

    <div className="mt-7 grid items-center gap-5 sm:grid-cols-[150px_1fr]">
      <span
        className={`mx-auto grid size-28 place-items-center rounded-full bg-gradient-to-br from-[#E9ECFF] via-[#EAF5FF] to-[#E8FAF4] text-[#5F6DDD] shadow-[0_18px_45px_rgb(70_82_184/0.14)] ring-1 ring-[#CFD5FF] sm:size-32`}
      >
        <BriefcaseIcon size={66} weight="duotone" />
      </span>

      <ul className="space-y-5">
        {points.map((point) => (
          <li
            key={point}
            className="relative flex items-center gap-3 text-xs font-bold text-[#272D6D] sm:text-sm"
          >
            <span
              className={`h-px w-12 bg-gradient-to-r from-[#4F8FEA] via-[#70B7F2] to-emerald-400`}
            />

            <span className="absolute left-[45px] size-1.5 rounded-full bg-emerald-400" />

            {point}
          </li>
        ))}
      </ul>
    </div>

    <p className="mt-8 flex items-start gap-2 text-xs leading-5 text-[#272D6D]/80 sm:text-sm">
      <SparkleIcon size={20} weight="fill" className="shrink-0 text-emerald-500" />
      Des exemples pré-rédigés vous aideront à compléter cette rubrique.
    </p>

    <button type="button" onClick={onContinue} className="sr-only">
      Afficher le formulaire
    </button>
  </section>
);
